export function initNavigation() {
  (function ($) {
    const $navbar = $("#main-navigation");
    const $logoWhite = $("#logo-white");
    const $logoColor = $("#logo-color");
    const $menuButton = $("#mobile-menu-toggle");
    const $menuIconOpen = $("#menu-icon-open");
    const $menuIconClose = $("#menu-icon-close");
    const $mobileMenu = $("#mobile-menu");
    const $body = $("body");
    let prevScrollPos = window.pageYOffset;
    const scrollThreshold = 100;
    let isOpen = false;

    const useGSAP = typeof gsap !== "undefined";

    // ✅ Open/Close menu toggle
    $menuButton.on("click", function () {
      isOpen = !isOpen;
      $(this).attr("aria-expanded", isOpen);
      isOpen ? openMenu() : closeMenu();
    });

    function openMenu() {
      $body.addClass("overflow-hidden");
      $menuIconOpen.addClass("hidden");
      $menuIconClose.removeClass("hidden");

      if (useGSAP) {
        $mobileMenu.removeClass("hidden pointer-events-none");
        gsap.fromTo(
          $mobileMenu,
          { x: "-100%", opacity: 0 },
          { x: "0%", opacity: 1, duration: 0.3, ease: "power2.inOut" }
        );
      } else {
        $mobileMenu
          .removeClass("hidden -translate-x-full")
          .addClass("translate-x-0");
      }
    }

    function closeMenu() {
      $body.removeClass("overflow-hidden");
      $menuIconClose.addClass("hidden");
      $menuIconOpen.removeClass("hidden");

      if (useGSAP) {
        gsap.to($mobileMenu, {
          x: "-100%",
          opacity: 0,
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            $mobileMenu.addClass("hidden pointer-events-none");
          },
        });
      } else {
        $mobileMenu.removeClass("translate-x-0").addClass("-translate-x-full");
        setTimeout(() => $mobileMenu.addClass("hidden"), 350);
      }
    }

    // ✅ Smooth scroll behavior
    $(window).on("scroll", { passive: true }, function () {
      if (isOpen) return;
      const currentScrollPos = window.pageYOffset;

      if (
        currentScrollPos > prevScrollPos &&
        currentScrollPos > scrollThreshold
      ) {
        $navbar.removeClass("translate-y-0").addClass("-translate-y-full");
      } else {
        $navbar.removeClass("-translate-y-full").addClass("translate-y-0");
      }

      if (currentScrollPos <= 50) {
        $navbar.removeClass("bg-white shadow-md").addClass("bg-transparent");
        $logoWhite.removeClass("opacity-0").addClass("opacity-100");
        $logoColor.removeClass("opacity-100").addClass("opacity-0");
      } else {
        $navbar.removeClass("bg-transparent").addClass("bg-white shadow-md");
        $logoWhite.removeClass("opacity-100").addClass("opacity-0");
        $logoColor.removeClass("opacity-0").addClass("opacity-100");
      }

      prevScrollPos = currentScrollPos;
    });

    // ✅ Submenu support (expand/collapse)
    $(document).on("click keydown", ".submenu-toggle", function (e) {
      if (e.type === "keydown" && !["Enter", " "].includes(e.key)) return;
      e.preventDefault();

      const $trigger = $(this);
      const $submenu = $trigger.closest("li").find("> .submenu");

      if ($submenu.length) {
        $submenu.stop(true, true).slideToggle(250).toggleClass("open");
        $trigger.find(".submenu-icon").toggleClass("rotate-90");
        const expanded = $trigger.attr("aria-expanded") === "true";
        $trigger.attr("aria-expanded", (!expanded).toString());
      }
    });
  })(jQuery);
}
